import {
  Box,
  Button,
  Center,
  Heading,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import axios from 'axios';
import { IAuthLoginDto } from 'dtos/auth.dto';
import useCatchError from 'hooks/useCatchError';
import useUser from 'hooks/useUser';
import { IAuthLoginResponse } from 'interfaces/auth.interface';
import { IUser } from 'interfaces/user.interface';
import _axios from 'libs/axios';
import NextLink from 'next/link';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import AuthLoginForm from './AuthLoginForm';

type AuthLoginModalProps = {
  visible: boolean;
  onClose: () => void;
};

function AuthLoginModal({ visible, onClose }: AuthLoginModalProps) {
  // init i18n
  const { t } = useTranslation(['auth', 'common']);

  // use catchError
  const catchError = useCatchError();

  // use user
  const { updateUser, mutateUser } = useUser();

  const { isOpen, onClose: onDisclosureClose } = useDisclosure({
    isOpen: visible,
  });

  // init loading state
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (values: IAuthLoginDto) => {
    try {
      console.log('values', values);

      setLoading(true);

      const { data } = await axios.post<IUser>(
        '/api/users/login-session',
        values
      );

      if (data.accessToken) {
        _axios.defaults.headers.common[
          'Authorization'
        ] = `Bearer ${data.accessToken}`;

        // update user by mutate SWR
        mutateUser(data, false);

        updateUser(data);

        handleClosed();
      }
    } catch (error) {
      catchError(error);
    } finally {
      setLoading(false);
    }
  };

  const handleClosed = () => {
    onDisclosureClose();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClosed} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalBody py={6}>
          <Box textAlign="center" mb={3}>
            <Heading>{t('auth.login.title')}</Heading>
            <ModalCloseButton />
          </Box>
          <Box mb={4} borderBottom="1px solid #eee" pb={4}>
            <AuthLoginForm
              onSubmit={handleSubmit}
              loading={loading}
            ></AuthLoginForm>
          </Box>
          <Center
            height="100%"
            bg="#EADECE"
            p={{
              base: 7,
              lg: 4,
            }}
          >
            <Box textAlign="center">
              <Heading as="h2" mb={3} fontWeight="300">
                {t('auth.register.callAction.title', {
                  // TH: สมัครสมาชิกใหม่
                  // EN: New member
                })}
              </Heading>
              <NextLink href="/register" passHref legacyBehavior>
                <Button as="a" bg="gray.800" minWidth="150px">
                  {t('auth.register.callAction.button', {
                    // TH: ลงทะเบียน
                    // EN: Register
                  })}
                </Button>
              </NextLink>
            </Box>
          </Center>
        </ModalBody>
      </ModalContent>
    </Modal>
  );
}

export default AuthLoginModal;
